import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import Input from '../components/Input'
import Button from '../components/Button'
import Loading from '../components/Loading'
import type { AdminSecondFactor } from '../contexts/AuthContext'
import './LoginPage.css'

export default function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [otpChallengeId, setOtpChallengeId] = useState<string | null>(null)
  const [otpFactors, setOtpFactors] = useState<AdminSecondFactor[]>([])
  const [otpDetail, setOtpDetail] = useState('')
  const [telegramCode, setTelegramCode] = useState('')
  const [totpCode, setTotpCode] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { login, verifyAdminIpOtp } = useAuth()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      if (otpChallengeId) {
        await verifyAdminIpOtp(otpChallengeId, { telegramCode, totpCode })
        return
      }
      const result = await login(email, password)
      if (result.status === 'admin_otp') {
        setOtpChallengeId(result.challengeId)
        setOtpFactors(result.factors)
        setOtpDetail(result.detail)
        setTelegramCode('')
        setTotpCode('')
      }
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Ошибка входа')
    } finally {
      setLoading(false)
    }
  }

  const resetOtpStep = () => {
    setOtpChallengeId(null)
    setOtpFactors([])
    setOtpDetail('')
    setTelegramCode('')
    setTotpCode('')
    setError('')
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <span className="logo">ALEX-DIGITAL</span>
          <h3>Вход в систему</h3>
        </div>
        {error && <div className="error-message">{error}</div>}
        {otpChallengeId && (
          <p className="login-otp-hint">
            {otpDetail || 'Подтвердите вход администратора.'}
          </p>
        )}
        <form onSubmit={handleSubmit} className="login-form">
          {!otpChallengeId ? (
            <>
              <Input
                id="email"
                type="text"
                label="Логин (email или admin)"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Введите логин или email"
                autoComplete="username"
              />
              <Input
                id="password"
                type="password"
                label="Пароль"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Введите пароль"
                autoComplete="current-password"
              />
            </>
          ) : (
            <>
              {otpFactors.includes('telegram') ? <Input
                id="telegram-otp"
                type="text"
                label="Код из Telegram"
                value={telegramCode}
                onChange={(e) => setTelegramCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                required
                placeholder="000000"
                autoComplete="one-time-code"
                inputMode="numeric"
                maxLength={6}
              /> : null}
              {otpFactors.includes('totp') ? <Input
                id="google-otp"
                type="text"
                label="Код Google Authenticator"
                value={totpCode}
                onChange={(e) => setTotpCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                required
                placeholder="000000"
                autoComplete="one-time-code"
                inputMode="numeric"
                maxLength={6}
              /> : null}
            </>
          )}
          {otpChallengeId && (
            <button type="button" className="login-back-link" onClick={resetOtpStep} disabled={loading}>
              Ввести пароль заново
            </button>
          )}
          <Button type="submit" variant="primary" disabled={loading} className="btn-login">
            {loading ? (
              <>
                <Loading size="sm" />
                {otpChallengeId ? 'Проверка…' : 'Вход…'}
              </>
            ) : otpChallengeId ? (
              'Подтвердить код'
            ) : (
              'Войти'
            )}
          </Button>
        </form>
      </div>
    </div>
  )
}
